import React, { Component } from 'react';
import propTypes from 'prop-types';
import { Alert, Button } from 'reactstrap';

/**
 * a basic error boundary
 */
export default class BasicBoundary extends Component {
  static propTypes = {
    children: propTypes.node
  };

  static defaultProps = {
    children: null
  };

  constructor(props) {
    super(props);
    this.state = {
      error: null
    };
  }

  componentDidCatch(error) {
    this.setState({
      error
    });
  }

  render() {
    return !this.state.error ? (
      this.props.children
    ) : (
      <div className="w-100">
        <Alert className="d-flex" color="danger">
          {this.state.error.toString()}
          <Button className="ml-auto" color="link" onClick={() => window.location.reload()}>
            try again
          </Button>
        </Alert>
      </div>
    );
  }
}
